export default __webpack_public_path__ + "static/media/AbsentVote.86bf1d6a.svg";